import { takeEvery, put } from 'redux-saga/effects';
import {
  ADD_SUCCESS,
  UPDATE_SUCCESS,
  SAVE_FILE_SUCCESS,
  REMOVE_SUCCESS,
  saveFile,
  getItemAdmin,
  getListAdmin,
} from './actions';

import { ROUTES } from '../../constants/routes';

export function* createArticleSuccess(history) {
  yield takeEvery(ADD_SUCCESS, function*(action) {
    yield history.push(`${ROUTES.ADMIN_ARTICLE_ITEM_PARAM}${action.data.id}`);
    yield put(saveFile(action.data.id));
  });
}

export function* updateArticleSuccess() {
  yield takeEvery(UPDATE_SUCCESS, function*(action) {
    yield put(
      saveFile(action.data.id, action.data.file.id, action.data.pdf.id),
    );
  });
}

export function* articleSaveFileSuccess() {
  yield takeEvery(SAVE_FILE_SUCCESS, function*(action) {
    yield put(getItemAdmin(action.data.itemId));
  });
}

export function* articleRemovedSuccess(history) {
  yield takeEvery(REMOVE_SUCCESS, function*() {
    yield put(getListAdmin());
    yield history.push(`${ROUTES.ADMIN_ARTICLES}`);
  });
}
